import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3a9dceac&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=3a9dceac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9dceac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9dceac')) {
      api.createRecord('3a9dceac', component.options)
    } else {
      api.reload('3a9dceac', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=3a9dceac&scoped=true", function () {
      api.rerender('3a9dceac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/list.vue"
export default component.exports